import React, {useEffect, useState} from "react";
import {Button} from "@mui/material";
import {Drawer} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";


export const ReportBuilder = ({view, showViewMenu, setShowViewMenu}) => {

    const [generation, setGeneration] = useState([]); // no-qa

    useEffect(() => {
        view.addOnPendingStateChangeCallback((changes) => {
            setGeneration(prev => prev + 1);
        });
        view.addOnStateChangeCallback((changes) => {
            setGeneration(prev => prev + 1);
        });

        return () => {
            view.addOnPendingStateChangeCallback(null);
            view.addOnStateChangeCallback(null);
        }
    });

    return <Drawer
        open={showViewMenu}
        onClose={() => setShowViewMenu(false)}
        className={"canold-table-aggregation-menu"} 
        anchor={"right"}
        variant={"temporary"}
        role={"report-builder-drawer"}
    >
        <div className={"mobile-close-aggregation-menu-button"}>
            <Button onClick={() => setShowViewMenu(false)} role={"close-report-builder"}>Close</Button>
        </div>

        <div className={"canold-table-aggregation-menu-header"}>
            <h1>
                Report Builder
                <CloseIcon onClick={() => setShowViewMenu(false)} className={"canold-table-aggregation-menu-close-icon"} role={"close-report-builder"}/>
            </h1>
            <br/>
        </div>

        <div className={"canold-table-view-menu-block"}>
            <div
                className={"canold-table-view-menu-group"}
                role={"canold-table-view-menu-calculate"}
            >
                <h2>Calculations</h2>
                <div className={"canold-table-view-menu-content"}>
                    {view?.renderAppliedCalculations()}
                    {view?.renderPendingCalculations()}
                    {(view?.getPendingCalculations().length || 0 > 0) && <hr/>}
                    {view?.renderCalculationFormRow()}
                </div>
            </div>
        </div>

        <div className={"canold-table-view-menu-block"}>
            <div
                className={"canold-table-view-menu-group"}
                role={"canold-table-view-menu-groupby"}
            >
                <h2>Group By Column(s)</h2>
                <div className={"canold-table-view-menu-content"}>
                    {view?.renderAppliedGroupBys()}
                    {view?.renderPendingGroupBys()}
                    {(view?.getPendingGroupBys().length || 0 > 0) && <hr/>}
                    {view?.renderGroupByFormRow()}
                </div>
            </div>

            <div
                className={"canold-table-view-menu-group"}
                role={"canold-table-view-menu-aggregateby"}
            >
                <h2>Aggregate</h2>
                <div className={"canold-table-view-menu-content"}>
                    {view?.renderAppliedAggregations()}
                    {view?.renderPendingAggregations()}
                    {(view?.getPendingAggregations().length || 0 > 0) && <hr/>}
                    {view?.renderAggregationFormRow()}
                </div>
            </div>
        </div>

        <div
            className={"canold-table-view-menu-group"}
            role={"canold-table-view-menu-filter"}
            style={{display: "flex", flexDirection: "row", justifyContent: "space-between"}}
        >
            {view?.renderResetButton()}
            {view?.renderRefreshButton()}
        </div>
    </Drawer>
};
